import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { Card, CardBody, CardHeader } from '../../components/other/card/card'
import { useGetBackgroundTasksQuery } from '../../redux/Api/AnalyticsApiSlice'
import Loader from '../pages/loader'
import TaskDefinitionCard from '../../components/backgroundTask/TaskDefinitionCard'
import { toast } from 'react-toastify'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

function BackgroundTasks () {
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('day'),
    dayjs().endOf('day')
  ])
  const [pollInterval, setPollInterval] = useState(null)

  const {
    data: backgroundTasksData,
    isLoading,
    error,
    isFetching,
    refetch
  } = useGetBackgroundTasksQuery(
    {
      expand: ['user'].join(','),
      date_range:
        dateRange && dateRange.length === 2
          ? `${dateRange[0].format('YYYY-MM-DD')},${dateRange[1].format(
              'YYYY-MM-DD'
            )}`
          : undefined,
      sync_tasks: true
    },
    {
      skip: !dateRange || dateRange.length !== 2,
      pollingInterval: pollInterval
    }
  )

  const TASK_TYPES = ['QUEUED', 'STARTED', 'SUCCESS', 'FAILURE']
  const context = useContext(AppSettings)

  
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return function cleanUp () {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [])

  useEffect(() => {
    if (!backgroundTasksData?.results) {
      setPollInterval(null)
      return
    }

    const hasActiveTask = backgroundTasksData.results.some(
      task => task.task.status === 'QUEUED' || task.task.status === 'STARTED'
    )

    if (hasActiveTask) {
      setPollInterval(15000)
    } else {
      setPollInterval(null)
    }
  }, [backgroundTasksData?.results])

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])
  return (
    <div className='flex flex-col gap-4 w-full'>
      <div className='mb-3 w-[300px] customeDate'>
        <RangePicker
          value={dateRange}
          format='YYYY-MM-DD'
          onChange={dates => setDateRange(dates)}
          allowClear={false}
          style={{ width: '100%' }}
        />
      </div>

      <Loader isLoading={isLoading || isFetching} />

      <div className='flex gap-4 w-full'>
        {TASK_TYPES.map((type, i) => (
          <div className='grow max-w-[25%]' key={i}>
            <Card>
              <CardHeader>{type}</CardHeader>
              <CardBody>
                {backgroundTasksData?.results
                  ?.filter(x => x.task.status === type)
                  .map(task => (
                    <TaskDefinitionCard key={task.task.id} task={task} />
                  ))}
              </CardBody>
            </Card>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BackgroundTasks
